import axios from "axios"

// Custom Component
// import DoRefreshToken from '../components/SignIn/DoRefreshToken'
import SignOut from '../components/SignIn/SignOut'

const store = require('store')

const getUser = async userType => {
	const getUser_api = "/siteuser"
	let params
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		const data = userType === "ALL" ? {status: true} : userType ? {status: true, is_internal: true} : {status: true, is_internal: false} 

		// const data = {
		// 	status: true,
		// 	is_internal: true
		// }

		params = data

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3001 + getUser_api,
			headers: headers,
			params: params
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const getUserGroupType = async () => {
	// const getUserGroupType_api = "/usergroup/ui/type"
	const getUserGroupType_api = "/usergroup/ui/type/options"
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3007 + getUserGroupType_api,
			headers: headers,
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const getUserGroup = async (typeSeq = "") => {
	const getUserGroup_api = "/usergroup"
	let params
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		const data = {
			type: typeSeq
		}

		params = data

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3007 + getUserGroup_api,
			headers: headers,
			params: params
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const createUserGroup = async (data) => {
	const createUserGroup_api = "/usergroup"
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'post',
			url: process.env.REACT_APP_API_URL_3007 + createUserGroup_api,
			headers: headers,
			data: data
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const modifyUserGroup = async (groupSeq, data) => {
	const modifyUserGroup_api = `/usergroup/${groupSeq}`
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'patch',
			url: process.env.REACT_APP_API_URL_3007 + modifyUserGroup_api,
			headers: headers,
			data: data
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const deleteUserGroup = async (groupSeq) => {
	const deleteUserGroup_api = `/usergroup/${groupSeq}`
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'delete',
			url: process.env.REACT_APP_API_URL_3007 + deleteUserGroup_api,
			headers: headers,
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


export {getUser, getUserGroupType, getUserGroup, createUserGroup, modifyUserGroup, deleteUserGroup}